import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TableCustomMini, { TableItem } from '@/design-system/molecules/TableCustomMini.vue'
import { translatedPriority, translatedStatus } from '@/utils/ticketHelpers'
import { Ticket } from '@/services/tickets.service'

type Props = {
  fields: any[]
  items?: Ticket[]
  tabOption: string
}
type Emits = {
  (e: 'archiveTicket'): void
  (e: 'deleteTicket'): void
  (e: 'loadMoreTickets'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableTicketsMini',
  props: {
    fields: {},
    items: {},
    tabOption: {}
  },
  emits: ["archiveTicket", "deleteTicket", "loadMoreTickets"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { t } = useI18n()

const piniaStore = useGeneralStore()
const store = useStore()
const ticketsTable = ref()
const ticketItems = computed<TableItem[]>(() => {
  if (!props.items) return []
  return props.items.map((item) => {
    return {
      id: item.id,
      name: item.title,
      sorting: getSorting(item),
      active: item.active
    }
  })
})
const selectedTicketId = computed(() => {
  return piniaStore.selectedTicket?.id ?? ''
})
const showOverlayModal = computed(() => {
  return store.state.showOverlayModal
})

function getSorting(item: Ticket) {
  switch (props.tabOption) {
    case 'status':
      return translatedStatus(item.status)
    case 'priority':
      return translatedPriority(item.priority)
    case 'dueDate':
      return item.dueDate ? item.dueDate.substring(2, 10) : ''
    default:
      return ''
  }
}
function openTicket(ticketId: string) {
  ticketsTable.value.closeMenu()
  if (!ticketId?.length) return piniaStore.setSelectedLink(null)
  selectTicket(ticketId)
  piniaStore.setCurrentOverlayModalPinia('editTicket')
  piniaStore.setShowOverlayModalPinia(true)
}
async function selectTicket(ticketId: string) {
  const selectedTicket = piniaStore.ticketsList.find((t) => t.id === ticketId)
  if (selectedTicket) piniaStore.setSelectedTicket(selectedTicket)
}
watch(showOverlayModal, () => {
  if (!showOverlayModal.value) {
    piniaStore.setSelectedTicket(null)
  }
})
watch(
  () => piniaStore.selectedTicket,
  () => {
    if (!piniaStore.selectedTicket) {
      ticketsTable.value.closeMenu()
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCustomMini, {
    ref_key: "ticketsTable",
    ref: ticketsTable,
    class: "table-custom-mini",
    fields: _ctx.fields,
    hasArchiveButton: _unref(store).getters.hasErrandEditorAccess,
    hasCreateButton: _unref(store).getters.hasErrandCreatorAccess,
    hasDeleteButton: _unref(store).getters.hasErrandAdminAccess,
    hasEditButton: _unref(store).getters.hasErrandEditorAccess,
    hasMenu: _unref(store).getters.hasErrandEditorAccess || _unref(store).getters.hasErrandAdminAccess,
    hasSorting: true,
    items: ticketItems.value,
    itemType: _unref(t)('general__label__tickets'),
    selectedId: selectedTicketId.value,
    wideSecondColumn: true,
    onArchiveItem: _cache[0] || (_cache[0] = ($event: any) => (emits('archiveTicket'))),
    onDeleteItem: _cache[1] || (_cache[1] = ($event: any) => (emits('deleteTicket'))),
    onEditItem: _cache[2] || (_cache[2] = ($event: any) => (openTicket(selectedTicketId.value))),
    onLoadMore: _cache[3] || (_cache[3] = ($event: any) => (emits('loadMoreTickets'))),
    onMenuClosed: _cache[4] || (_cache[4] = ($event: any) => (_unref(piniaStore).setSelectedTicket(null))),
    onMenuOpened: _cache[5] || (_cache[5] = ($event: any) => (selectTicket($event)))
  }, {
    "preview-heading": _withCtx(() => _cache[6] || (_cache[6] = [
      _createElementVNode("span", { style: {"width":"48px"} }, null, -1)
    ])),
    preview: _withCtx(({ item }) => [
      _createVNode(ButtonText, {
        class: _normalizeClass(["table-custom-mini__button", { selected: item.id === selectedTicketId.value }]),
        iconLeft: require('@/design-system/assets/icons/Icon-Arrow-up-right.svg'),
        size: "extra-small",
        whiteContent: false,
        onOnClicked: ($event: any) => (openTicket(item.id))
      }, null, 8, ["class", "iconLeft", "onOnClicked"])
    ]),
    _: 1
  }, 8, ["fields", "hasArchiveButton", "hasCreateButton", "hasDeleteButton", "hasEditButton", "hasMenu", "items", "itemType", "selectedId"]))
}
}

})